import { ReactElement } from 'react'
import { useParams } from 'react-router-dom'
import { AxiosError } from 'axios'
import { LoadingButton } from '@mui/lab'
import { Stack } from '@mui/material'
import { useResultsInvalidation } from '@editor/hooks'
import { useModelInvalidation } from '@editor/pages/StructuralPlanning/hooks'
import { useMutation } from '@tanstack/react-query'
import { useSnackbar } from '@ui/snackbar'
import { buildErrorMessage } from 'src/constants/errors'
import { alignWalls } from 'src/state/mutations/alignWalls'
import WallAlignmentConfirmDialog from '../../../../../WallAlignmentConfirmDialog'

const WallAlignmentForm = (): ReactElement => {
  const { enqueueSnackbar } = useSnackbar()
  const { projectId }: { projectId?: string } = useParams()
  const invalidateResults = useResultsInvalidation()
  const invalidateModel = useModelInvalidation()

  const { mutate: startAlignWalls, isLoading: isAligningWalls } = useMutation(
    () => {
      return alignWalls.request(projectId as string)
    },
    {
      onSuccess: async () => {
        await invalidateModel(projectId as string)
        invalidateResults(projectId as string)
        enqueueSnackbar('Wände erfolgreich ausgerichtet', { variant: 'success' })
      },
      onError: (error: AxiosError) => {
        enqueueSnackbar(buildErrorMessage(error, 'Fehler beim Ausrichten der Wände'), {
          variant: 'error',
        })
      },
    },
  )

  return (
    <>
      <Stack direction="column" justifyContent="end" spacing={1} mt={1}>
        <WallAlignmentConfirmDialog onConfirm={() => startAlignWalls()}>
          <LoadingButton
            variant="contained"
            loading={isAligningWalls}
            fullWidth
            disabled={false}
            data-cy="btn-submit-align-walls"
            size="small"
          >
            Wände an SW zuschneiden
          </LoadingButton>
        </WallAlignmentConfirmDialog>
      </Stack>
    </>
  )
}

export default WallAlignmentForm
